export function handleSearchText (text: any) {
    return { type: "HANDLE_SEARCH_TEXT", payload: text };
  }
  